<template>
	<div style="position: relative;">
		<audio src="../assets/audio/bgm.mp3" ref="bgm" loop></audio>
		<!-- 首页 -->
		<div class="page home-page" v-if="page_index==1">
			<img class="bg" src="../assets/sybg.png" alt="" />
			<!-- 【本次新增】首页电影感装饰层：暗角、扫光、漂浮尘埃，不参与点击 -->
			<div class="home-vignette"></div>
			<div class="home-light"></div>
			<div class="home-dust" aria-hidden="true">
				<i v-for="n in 14" :key="'dust-'+n" :style="dustStyle(n)"></i>
			</div>
			<img class="btn-start" src="../assets/djks.png" alt="点击开始" @click="handleStart" />
			<img class="logo" src="../assets/logo.png" alt="" />
		</div>
		<!-- 视频展示页 -->
		<div class="page" v-if="page_index==2">
			<video ref="videoPlayer" class="video-player" webkit-playsinline playsinline x5-video-player-type="h5"
				 @ended="onVideoEnded">
				<source src="https://yanfa-upload-1330455741.cos.ap-beijing.myqcloud.com/appapi/tsddzznpro/shipin.mp4" type="video/mp4" />
			</video>
			<img @click="tiaoguo" src="../assets/tg.png" class="tiaoguo2"/>
		</div>
		<!-- 时空变化 -->
		<div :class="['page', 'timeline-page', 'bg_'+year, switching ? 'warping warping-' + warpMode : '']"
			 :style="sceneStyle" @mousemove="moveScene" @touchmove="moveScene" v-if="page_index==3">
			<!-- 【本次新增】地图页电影感背景：慢速推进、暗角和柔光；背景从原 page 移到独立层便于做动画 -->
			<div :class="['map-cinematic-bg', 'map-cinematic-bg-'+year]"></div>
			<div class="map-vignette"></div>
			<div class="map-light"></div>
			<div class="scene-depth scene-depth-back"></div>
			<div class="scene-depth scene-depth-front"></div>
			<div class="ambient-particles" v-if="year==1976" aria-hidden="true">
				<!-- 【本次新增】仅1976地图保留暖金环境粒子；2026科技粒子已按需求移除 -->
				<i v-for="n in 18" :key="year+'-particle-'+n" :style="particleStyle(n)"></i>
			</div>
			<div v-if="year==1976">
				<div v-for="(item,index) in list" :key="'old-'+index" @click="build(index,1976)" :class="'build build_1976 '+(switching?'':'suofang delay'+index)" :style="img_style_list[index]">
					<img :src="item.img1976"/>
					<div style="display: flex;justify-content: center;">
						<div class="build_name">{{item.pictitle1976}}</div>
					</div>
					
				</div>
				<div v-if="yd_flag1" @click="yindao(1)" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, 0.7);z-index: 99999;">
					<div v-if="index==0" v-for="(item,index) in list" :class="'build build_1976 '+(switching?'':'suofang delay'+index)" :style="img_style_list[index]">
						<img :src="item.img1976"/>
						<div style="display: flex;justify-content: center;">
							<div class="build_name">{{item.pictitle1976}}</div>
						</div>
						<img src="../assets/yd1.png" style="position: absolute;top: 35%;left: 60%;width: 80%;" class="suofang2"/>
					</div>
					<img src="../assets/xyb.png" style="position: absolute;top: 60%;left: 35%;width: 30%;"/>
				</div>
				
				
				<div class="threeDView">
					<img src="../assets/skbh.png" class="skbh" @click="skbh(2026)"/>
					<br />
					<!-- <img @click="go_iframe" src="../assets/ksj.png" class="threeD" style="visibility: hidden;pointer-events: none;"/> -->
				</div>
				
				<!-- <div v-if="yd_flag2" @click="yindao(2)" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, 0.7);z-index: 99999;">
					<div class="threeDView">
						<img src="../assets/ksj.png" class="threeD"/>
						<img src="../assets/yd2.png" style="position: absolute;bottom: 5%;right: 55%;width: 24%;" class="suofang2"/>
					</div>
					<img src="../assets/zdl.png" style="position: absolute;top: 50%;left: 35%;width: 30%;"/>
				</div> -->
				
			</div>
			<div v-if="year==2026">
				<div v-for="(item,index) in list" :key="'new-'+index" @click="build(index,2026)" :class="'build build_1976 build_2026 '+(switching?'':'suofang delay'+index)" :style="img_style_list[index]">
					<img :src="item.img2026"/>
					<div style="display: flex;justify-content: center;">
						<div class="build_name">{{item.pictitle2026}}</div>
					</div>
				</div>
				<!-- 'top: 42%;left: 60%;','top: 52%;left: 32%;','top: 41%;left: 5%;' -->
				<div @click="go_iframe(2)" :class="'build build_1976 build_2026 '+(switching?'':'suofang delay0')" style="top: 60%;left: 63%;">
					<img src="../assets/bowuguan.png"/>
					<div style="display: flex;justify-content: center;">
						<div class="build_name">博物馆前广场</div>
					</div>
				</div>
				<div @click="go_iframe(1)" :class="'build build_1976 build_2026 '+(switching?'':'suofang delay1')" style="top: 70%;left: 32.5%;">
					<img src="../assets/kangzhen.png"/>
					<div style="display: flex;justify-content: center;">
						<div class="build_name">抗震纪念碑</div>
					</div>
				</div>
				<div @click="go_iframe(0)" :class="'build build_1976 build_2026 '+(switching?'':'suofang delay3')" style="top: 60%;left: 3%;">
					<img src="../assets/bowuguan.png"/>
					<div style="display: flex;justify-content: center;">
						<div class="build_name">南湖公园</div>
					</div>
				</div>
				<!-- <img @click="build" src="../assets/2026.png" class="build build_2026" style="top: 30%;left: 20%;"/> -->
				<div class="threeDView">
					<img src="../assets/skbh2.png" class="skbh" @click="skbh(1976)"/>
					<br />
					<!-- <img @click="go_iframe" src="../assets/ksj.png" class="threeD"/> -->
				</div>
				
			</div>
			
			
			<!-- <img @click="fanhui(1)" src="../assets/fh.png" class="tiaoguo"/> -->

			<!-- 时空切换动画遮罩 -->
			<div :class="['warp-mask', warpMode]" v-if="switching">
				<div class="warp-tunnel"></div>
				<div class="warp-ring"></div>
				<div class="warp-scan"></div>
				<div class="warp-glitch g1"></div>
				<div class="warp-glitch g2"></div>
				<div class="warp-flash"></div>
				<div class="warp-year">{{ targetYear }}</div>
			</div>
		</div>
		
		<!-- 建筑详情页 -->
		<div class="page4" v-if="page_index==4">
			<swiper class="detail-swiper" ref="detailSwiper" :options="detailSwiperOptions" @slideChange="playActiveVideo">
				<swiper-slide v-for="(item, index) in list" :key="index">
					<div>
						<video  class="build-video-player" webkit-playsinline playsinline x5-video-player-type="h5" preload="auto" crossorigin="anonymous" :poster="item.videocoverimg" @ended="onBuildVideoEnded">
							<source :src="item.videourl+'?t='+Math.random()" type="video/mp4" />
						</video>
					</div>
					<div style="position: absolute;top: 60px;left: 0;width: 100%;z-index: 5;" v-if="dmList2.length>0&&video_played">
						<!-- 【本次修改】弹幕根据1976/2026切换暖金或蓝色玻璃样式 -->
						<vue-danmaku :ref="'danmaku'+index" :class="['danmaku-stage', 'danmaku-stage-'+detail_year]" style="height:85px; width:100%;" v-model="dmList2" use-slot loop
							:speeds="50" :channels="2" :top="5" :right="0" :randomChannel="true">
							<template v-slot:dm="{ index, danmu }">
								<div class="dmlist">{{danmu}}</div>
							</template>
						</vue-danmaku>
						<!-- 【本次新增】城市成就默认不遮挡照片，通过右侧悬浮入口触发展示 -->
						<button v-if="detail_year==2026" class="achievement-trigger" type="button" @click.stop="achievementVisible=true">
							<span class="achievement-trigger-icon"><i>✦</i></span>
							<span><b>解锁城市新成就</b><small>{{ item.honorlist ? item.honorlist.length : 0 }} 项荣誉等你发现</small></span>
							<i>›</i>
						</button>
						
					</div>
					<!-- 【本次新增】三项城市成就弹层：点击遮罩空白或关闭按钮收起 -->
					<transition name="achievement-sheet">
						<div v-if="achievementVisible&&detail_index==index" class="achievement-overlay" @click.self="achievementVisible=false">
							<div class="achievement-panel">
								<button class="achievement-close" type="button" @click="achievementVisible=false">×</button>
								<div class="achievement-heading">
									<span></span><b>唐山 · 城市新成就</b><span></span>
								</div>
								<!-- 【本次修改】成就内容直接读取后台 list.php 返回的 item.honorlist 图片数组 -->
								<div v-for="(honorImage, achievementIndex) in item.honorlist" :key="honorImage || achievementIndex"
									 :class="['achievement-card', 'achievement-card-'+achievementIndex]">
									<img :src="honorImage" class="achievement-image" alt="唐山城市新成就"/>
								</div>
								<div class="achievement-hint">点击空白区域即可收起</div>
							</div>
						</div>
					</transition>
					<div v-if="detail_year==1976" :class="'zhezhao1976 '+(video_playing?'zhezhao1976_playing':'')"></div>
					<div v-if="detail_year==2026" class="zhezhao2026"></div>
					<div style="position: absolute;bottom: 0;left: 0;width: 100%;box-sizing: border-box;padding-top: 30px;">
						<!-- 建筑1976详情 -->
						<div v-if="detail_year==1976" key="detail1976">
							<div v-if="!video_playing">
								<div style="padding: 0 10px;">
									<div class="detail_title detail_title_bg_1976">{{item.title1976}}</div>
									<!-- 【本次新增】1976说明文字折叠/展开区域 -->
									<div @click.stop="toggleDetail(index, 1976)" :class="['detail-content-wrap', {'is-expanded': isDetailExpanded(index, 1976)}]">
										<div class="detail_content" v-html="item.copywriting1976.replaceAll('font-size', 'fontsize')"></div>
										<div class="detail-content-fade"></div>
									</div>
									<!-- <button class="detail-expand-btn" type="button" @click.stop="toggleDetail(index, 1976)">
										{{ isDetailExpanded(index, 1976) ? '收起' : '展开' }}
										<span :class="['expand-arrow', {'up': isDetailExpanded(index, 1976)}]">v</span>
									</button> -->
								</div>
								<div style="display: flex;align-items: center;justify-content: center;width: 80%;margin: 0 auto;margin-top: 5vh;">
									<img @click="goDetailYear(2026)" src="../assets/skbh.png" style="width: 40%;" class="suofang11"/>
								</div>
							</div>
							
							<div :style="'text-align: center;margin-top: 12vh;'+(detail_index==list.length-1?'visibility: hidden;':'')">
								<img src="../assets/sh.png" style="width: 25%;" class="shang"/>
							</div>
						</div>
						<transition name="fade" mode="out-in">
							
							<!-- 建筑2026详情 -->
							<div v-if="detail_year==2026" key="detail2026">
								<!-- <div style="text-align: center;">
									<img @click="goDetailYear(1976)" src="../assets/fh1976.png" style="width: 35%;"/>
								</div> -->
								<div style="padding: 0 10px;position: relative;">
									<!-- <div>
										<img @click="go_iframe" src="../assets/3dsj.png" style="width: 60px;margin-left: 10px;margin-bottom: 10px;"/>
									</div> -->
									
									<div class="detail_title detail_title_bg_2026">{{item.title2026}}</div>
									<!-- 【本次新增】2026说明文字折叠/展开区域 -->
									<div @click.stop="toggleDetail(index, 2026)" :class="['detail-content-wrap', 'detail-content-wrap-2026', {'is-expanded': isDetailExpanded(index, 2026)}]">
										<div class="detail_content" v-html="item.copywriting2026.replaceAll('font-size:19px', '')"></div>
										<div class="detail-content-fade"></div>
									</div>
									<!-- <button class="detail-expand-btn detail-expand-btn-2026" type="button" @click.stop="toggleDetail(index, 2026)">
										{{ isDetailExpanded(index, 2026) ? '收起' : '展开' }}
										<span :class="['expand-arrow', {'up': isDetailExpanded(index, 2026)}]">v</span>
									</button> -->
									<!-- 点赞飘爱心 -->
									<div class="like-box">
										<img @click="dianzan(index)" src="../assets/heart/heart.png" class="like-btn"/>
										<div class="like-num">{{get_like_num_text(item.zan)}}</div>
									</div>
									<img v-for="h in hearts" :key="h.id" :src="h.img" class="fly-heart" :style="{left: h.left+'%', width: h.size+'px', animationDuration: h.duration+'s'}"/>
									
								</div>
								<div style="display: flex;align-items: center;justify-content: space-between;width: 80%;margin: 0 auto;margin-top: 5vh;">
									<!-- 【本次修改】海报按钮：增加轻微漂浮/呼吸动效，人数标签缩小 -->
									<div @click="schb" class="action-motion action-motion-poster" style="position: relative;font-size: 0;width: 45%;">
										<img src="../assets/schb.png" class="action-motion-img" style="width: 100%;"/>
										<div class="sc-view">
											<span>已有</span><span class="bold">{{get_like_num_text(item.zan1)}}</span><span>人生成</span>
										</div>
									</div>
									<!-- 【本次修改】弹幕按钮：与海报按钮错峰运动，人数标签缩小 -->
									<div @click="dm_pup=true" class="action-motion action-motion-danmaku" style="position: relative;font-size: 0;width: 45%;">
										<img src="../assets/fdm.png" class="action-motion-img" style="width: 100%;"/>
										<div class="fb-view">
											<span>已有</span><span class="bold">{{get_like_num_text(item.zan2)}}</span><span>人发布</span>
										</div>
									</div>
								</div>
								<div :style="'text-align: center;margin-top: 20px;'+(detail_index==list.length-1?'visibility: hidden;':'')">
									<img src="../assets/sh.png" style="width: 25%;" class="shang"/>
								</div>
								
								
							</div>
							
						</transition>
						
						
					</div>
				</swiper-slide>
			</swiper>
			
			<van-popup v-model="dm_pup" round position="bottom">
				<div class="custom-popup-content">
					<!-- 【本次新增】祝福弹幕弹窗关闭按钮 -->
					<button type="button" class="popup-close-btn" aria-label="关闭弹幕弹窗" @click="dm_pup=false">×</button>
					<div style="position: relative;font-size: 0;">
						<img src="../assets/tc_top.png" style="width: 100%;"/>
					</div>
					<div style="width: 100%;position: relative;background-color: #fff;padding: 5px 10px 0;z-index: 2;margin-top: -1px;">
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<div class="tc_title">祝福弹幕</div>
							<img @click="hyh" src="../assets/hyh.png" style="width: 5rem;"/>
						</div>
						<div style="margin-top: 20px;">
							<div :class="'dm_item '+(dm_act==index?'dm_act':'')" v-for="(item,index) in dmList" @click="dm_act = index">{{item}}</div>
							
						</div>
						<div style="text-align: center;margin-top: 5px;">
							<img @click="fsdm" src="../assets/fsdm.png" style="width: 45%;"/>
						</div>
					</div>
					
					<div style="position: relative;font-size: 0;margin-top: -30px;">
						<img src="../assets/tc_bot.png" style="width: 100%;"/>
					</div>
				</div>
			</van-popup>
			<!-- 海报选择 -->
			<van-popup v-model="hb_pup" round position="bottom">
				<div class="custom-popup-content">
					<!-- 【本次新增】海报选择弹窗关闭按钮 -->
					<button type="button" class="popup-close-btn" aria-label="关闭海报弹窗" @click="hb_pup=false">×</button>
					<div style="position: relative;font-size: 0;">
						<img src="../assets/tc_top.png" style="width: 100%;"/>
					</div>
					<div style="width: 100%;position: relative;background-color: #fff;padding: 5px 10px 0;z-index: 2;margin-top: -1px;">
						<div>
							<div class="tc_title">专属纪念海报</div>
						</div>
						<div style="margin-top: 12px;">
							<div class="tc_title2">选择模版</div>
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 3px;">
							<div :class="'hb_item '+(hb_act2==index?'hb_act':'')" v-for="(item,index) in hbList" @click="hb_act2 = index">
								<img :src="item.poster_smallurl" style="width: 100%;"/>
							</div>
							
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;margin-top: 25px;">
							<div class="tc_title2">选择个性化文字</div>
							<img @click="hyh2" src="../assets/hyh.png" style="width: 4.5rem;"/>
						</div>
						<div style="margin-top: 10px;">
							<div :class="'dm_item '+(hb_act==index?'dm_act':'')" v-for="(item,index) in hb_dmList" @click="hb_act = index">{{item}}</div>
							
						</div>
						<div style="text-align: center;margin-top: 5px;">
							<img @click="schbFn" src="../assets/schb.png" style="width: 45%;"/>
						</div>
					</div>
					
					<div style="position: relative;font-size: 0;margin-top: -50px;">
						<img src="../assets/tc_bot.png" style="width: 100%;"/>
					</div>
				</div>
			</van-popup>
			<img @click="fanhui(3)" src="../assets/fh.png" class="tiaoguo"/>
			
			<div v-if="hb_flag" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, 0.7);z-index: 99999;">
				
				<div style="text-align: center;position: absolute;top: 50%;left: 0;width: 100vw;transform: translateY(-50%);">
					<div style="font-size: 0.95rem;color: #fff;">长按保存至手机</div>
					<!-- 【本次新增】最终海报悬浮舞台：包含悬浮阴影和斜向闪光层 -->
					<div class="poster-preview-stage">
						<div class="poster-preview-card">
							<img :src="hb_img" class="poster-preview-img"/>
							<div class="poster-preview-shine"></div>
						</div>
					</div>
					<div>
						<img @click="hb_flag=false" src="../assets/guanbi.png" style="width: 40px;margin-top: 5px;"/>
					</div>
				</div>
			</div>
			
			
		</div>
		<div v-if="loading" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;background-color: rgba(0, 0, 0, 0.7);z-index: 99999;">
			<img src="../assets/loading.gif" style="width: 40px;position: absolute;top: 45%;left: 50%;transform: translateX(-50%);"/>
		</div>
		
		<div style="position: fixed;top: 0px;left: 120%;width: 707px;z-index: 9999;font-size: 0;" ref="shareDiv">
			<img :src="hb_act2!=null?hbList[hb_act2].poster_bigurl:''" style="width: 100%;"/>
			<div style="display: flex;align-items: center;justify-content: center;position: absolute;top: 35px;width: 100%;left: 0;">
				<img :src="headimg" style="width: 63px;border-radius: 50%;margin-right: 12px;border: 2px solid #FFFFFF;"/>
				<div style="color: #fff;font-size: 24px;margin-right: 17px;">{{nickname}}</div>
				<div style="height: 63px;position: relative;font-size: 0;display: flex;align-items: center;">
					<img src="../assets/qipao/1.png" style="height: 100%;"/>
					<div class="qipao2">{{hb_dmList[hb_act]}}</div>
					<img src="../assets/qipao/3.png" style="height: 100%;"/>
				</div>
				
			</div>
			<div style="font-weight: 500;font-size: 24px;color: #FFFFFF;position: absolute;bottom: 36px;left: 22px;">已有 {{fwl_num}} 人参与</div>
			<img :src="qrCode" style="width: 115px;height: 115px;right: 3.8%;bottom: 2.15%;position: absolute;"/>
		</div>
		
		<!-- 展示iframe页面 -->
		 <!-- @click="reSetTime" @mousemove="reSetTime" @touchmove="reSetTime" -->
		<div v-if="iframe_flag" style="position: fixed;top: 0;left: 0;width: 100vw;height: 100vh;z-index: 99999;background-color: #000;">
			<iframe id="viewer" style="width: 100vw;height: 100vh;border: none;outline: none;" allow="fullscreen; xr-spatial-tracking allow-scripts allow-same-origin" :src="iframe_list[iframe_url_index].url"></iframe>
			
			
			<div style="position: absolute;top: 0;left: 0;width: 100%;padding-bottom: 20px;">
				<div style="height: 50px;background-color: #fff;position: absolute;top: 0;left: 0;width: 100%;">
					
				</div>
				<div style="background: linear-gradient( 180deg, #000000 0%, rgba(0,0,0,0) 100%);position: absolute;top: 0;left: 0;width: 100%;height: 100%;pointer-events: none;"></div>
				
				<!-- 切换的swiper写在这 -->
				<div class="iframe-tabbar">
					<!-- <img src="../assets/iframe/zuo.png" class="iframe-arrow" @click="iframePrev"/>
					<swiper class="iframe-swiper" ref="iframeSwiper" :options="iframeSwiperOptions" @slideChange="onIframeSlideChange">
						<swiper-slide v-for="(item,index) in iframe_list" :key="index">
							
						</swiper-slide>
					</swiper>
					<img src="../assets/iframe/you.png" class="iframe-arrow" @click="iframeNext"/>
					 -->
					<div v-for="(item,index) in iframe_list" :key="index" :class="'iframe-tab '+(iframe_url_index==index?'iframe-tab-act':'')" @click="iframeTabClick(index)">{{item.name}}</div>
				</div>
				<img @click="iframeBack" src="../assets/iframe/fanhui3.png" class="tiaoguo3"/>
				
			</div>
			
			
			<img v-if="yd_iframe1" class="yd_iframe" @click="yindao_iframe(1)" src="../assets/iframe/yd1.png"/>
			<img v-if="yd_iframe2" class="yd_iframe" @click="yindao_iframe(2)" src="../assets/iframe/yd2.png"/>
			<img v-if="yd_iframe3" class="yd_iframe" @click="yindao_iframe(3)" src="../assets/iframe/yd3.png"/>
		</div>
		
		
		
		<!-- ==================== 【点赞动画新增-开始】以下整个 pride-fx 区块为新增模板 ==================== -->
		<!-- 点赞反馈采用现代产品风格：渐变光晕、粒子、扩散圆环和玻璃状态卡 -->
		<div v-if="prideFxVisible" :key="prideFxKey" class="pride-fx" aria-hidden="true">
			<div class="pride-fx-red-wave"></div>
			<div class="pride-fx-rays"></div>
			<div class="pride-fx-ring ring-one"></div>
			<div class="pride-fx-ring ring-two"></div>
			<div class="pride-fx-sparks">
				<i v-for="n in 28" :key="n" :style="prideSparkStyle(n)"></i>
			</div>
			<div class="pride-fx-copy">
				<div class="pride-fx-star">✓</div>
				<div class="pride-fx-title">点赞成功 <em>+1</em></div>
				<div class="pride-fx-line"><span></span><b>一起见证唐山向新而生</b><span></span></div>
			</div>
		</div>
		<!-- ==================== 【点赞动画新增-结束】pride-fx 新增模板结束 ==================== -->
	</div>
	
</template>


<script>
	import vueDanmaku from 'vue-danmaku'
	import 'swiper/css/swiper.min.css'
	import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
	import QRCode from 'qrcode'
	import html2canvas from 'html2canvas'
	import {
		getFwl,
		getList,
		getDmList,getPoster
	} from '@/api'
	import { Toast } from 'vant'
	export default {
		
		
		
		 
		name: 'index',
		components: {
		  // 2. 注册
		    vueDanmaku,
			Swiper,
			SwiperSlide
		  },
		data() {
			return {
				iframe_flag:false,
				iframe_list:[
					{
						url:'https://appapi.hebei.com.cn/ts072807/index.html',
						name:'南湖公园'
					},
					{
						url:'https://appapi.hebei.com.cn/ts072805/index.html',
						name:'抗震纪念碑'
					},
					
					{
						url:'https://appapi.hebei.com.cn/ts072809/index.html',
						name:'博物馆前广场'
					}
				],
				iframe_url_index:0,
				iframeSwiperOptions: {
					slidesPerView: 3,
					centeredSlides: true,
					initialSlide: 0
				},
				yd_flag1:false,
				yd_flag2:false,
				
				
				yd_iframe1:false,
				yd_iframe2:false,
				yd_iframe3:false,
				
				qrCode:null,
				hb_img:'',
				hb_flag:false,
				
				loading:false,
				page_index:1,
				year: 1976,
				switching: false,
				targetYear: null,
				warpMode: 'tech',
				sceneX: 0,
				sceneY: 0,
				hb_pup:false,
				hbList:[],
				
				dm_pup: false,
				
				
				dmList:[],
				dmList2:[],
				list:[],
				detail_data:{},
				detail_year:null,
				detail_index: 0,
				video_played:false,
				video_playing:false,
				detailSwiperOptions: {
					direction: 'vertical',
					// loop: true,
					initialSlide: 0,
					resistanceRatio: 0.6
				},
				img_style_list:[
					'top: 26%;left: 20%;','top: 27%;left: 55%;','top: 42%;left: 60%;','top: 52%;left: 32%;','top: 41%;left: 5%;'
				],
				
				dm_act:null,
				hb_act:null,
				
				hb_act2:null,
				
				hb_dmList:[],
				
				headimg:'',
				nickname:'',
				
				
				fwl_num:null,

				like_num:1980000,
				hearts:[],
				// 【本次新增】按“年代-建筑索引”分别保存说明文字的展开状态
				expandedDetails:{},
				// 【本次新增】控制城市成就弹层显示/隐藏
				achievementVisible:false,
				// ==================== 【点赞动画新增-开始】点赞特效状态字段 ====================
				prideFxVisible:false,
				prideFxKey:0,
				prideFxTimer:null,
				// ==================== 【点赞动画新增-结束】点赞特效状态字段 ====================
				heart_id:0,
				heart_imgs:[
					require('../assets/heart/Shape1.png'),
					require('../assets/heart/Shape2.png'),
					require('../assets/heart/Shape3.png'),
					require('../assets/heart/Shape4.png'),
					require('../assets/heart/Shape5.png')
				],
				
				
				timmer:null
			}
		},
		
		mounted() {
			this.headimg = headimg
			this.nickname = nickname
			getFwl().then(res => {
				var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
				if (data && data.data) {
					this.fwl_num = data.data.pv
				}
			}).catch(function(err) {
			  
			})
			this.getListFn()
			this.getDmListFn()
			this.getPosterFn()
			// document.addEventListener('click', this.handleGlobalClick, true)
		},
		beforeDestroy() {
			// 【点赞动画新增】组件销毁时清理特效定时器，避免内存泄漏
			clearTimeout(this.prideFxTimer)
			// document.removeEventListener('click', this.handleGlobalClick, true)
		},
		methods: {
			iframeBack(){
				this.iframe_flag=false
				if(this.timmer){
					clearInterval(this.timmer)
					this.timmer= null
				}
				this.iframe_url_index=0
			},
			
			reSetTime(){
				console.log("reSetTime")
				if(this.timmer){
					clearInterval(this.timmer)
					this.timmer= null
				}
				this.timmer = setInterval(()=>{
					
					if(this.iframe_url_index==this.iframe_list.length-1){
						
						this.iframe_url_index=0
					}else{
						this.iframe_url_index++
					}
					console.log("切换iframe_url_index:",this.iframe_url_index)
					if(this.$refs.iframeSwiper && this.$refs.iframeSwiper.$swiper){
						this.$refs.iframeSwiper.$swiper.slideTo(this.iframe_url_index)
						console.log("2切换iframe_url_index:",this.iframe_url_index)
					}
				},5000)
			},
			// ==================== 【点赞动画新增-开始】生成全屏彩色粒子的方向、颜色和距离 ====================
			prideSparkStyle(n){
				const angle = n * 137.5 * Math.PI / 180
				const distance = 120 + (n % 7) * 36
				return {
					'--spark-x': (Math.cos(angle) * distance) + 'px',
					'--spark-y': (Math.sin(angle) * distance) + 'px',
					'--spark-rotate': (n * 47) + 'deg',
					'--spark-color': 'hsl(' + ((n * 47) % 360) + ',85%,65%)',
					animationDelay: (n * .016) + 's'
				}
			},
			// ==================== 【点赞动画新增-结束】粒子样式生成方法 ====================
			go_iframe(index){
				this.iframe_flag=true
				this.iframe_url_index = index
				var ydflag = localStorage.getItem("yindao_iframe")
				if (!ydflag) {
					this.yd_iframe1 = true
					
				} 
				// this.reSetTime()
			},
			onIframeSlideChange(){
				// 滑动切换场景，同步iframe地址
				if(!this.$refs.iframeSwiper || !this.$refs.iframeSwiper.$swiper) return
				this.iframe_url_index = this.$refs.iframeSwiper.$swiper.activeIndex
			},
			iframeTabClick(index){
				this.iframe_url_index = index
				// if(this.$refs.iframeSwiper && this.$refs.iframeSwiper.$swiper){
				// 	this.$refs.iframeSwiper.$swiper.slideTo(index)
				// }
			},
			iframePrev(){
				if(this.$refs.iframeSwiper && this.$refs.iframeSwiper.$swiper){
					this.$refs.iframeSwiper.$swiper.slidePrev()
				}
			},
			iframeNext(){
				if(this.$refs.iframeSwiper && this.$refs.iframeSwiper.$swiper){
					this.$refs.iframeSwiper.$swiper.slideNext()
				}
			},
			// 【本次新增】生成说明文字展开状态的唯一键，避免不同建筑/年代互相影响
			detailExpandKey(index, year){
				return year + '-' + index
			},
			isDetailExpanded(index, year){
				return !!this.expandedDetails[this.detailExpandKey(index, year)]
			},
			toggleDetail(index, year){
				const key = this.detailExpandKey(index, year)
				this.$set(this.expandedDetails, key, !this.expandedDetails[key])
			},
			// 【本次新增】为首页尘埃生成固定分布和不同动画时长
			dustStyle(n){
				return {
					left: ((n * 37) % 100) + '%',
					top: ((n * 61) % 100) + '%',
					animationDelay: (-n * 0.73) + 's',
					animationDuration: (5 + (n % 5)) + 's'
				}
			},
			particleStyle(n){
				return {
					left: ((n * 43) % 100) + '%',
					top: ((n * 29) % 92) + '%',
					animationDelay: (-n * 0.46) + 's',
					animationDuration: (4.5 + (n % 6) * 0.7) + 's'
				}
			},
			// 【本次新增】地图页轻量视差：把鼠标/手指位置转换为CSS变量
			moveScene(e){
				const point = e.touches ? e.touches[0] : e
				if(!point) return
				this.sceneX = (point.clientX / window.innerWidth - 0.5) * 2
				this.sceneY = (point.clientY / window.innerHeight - 0.5) * 2
			},
			get_like_num_text(num){
				return num>=10000 ? Math.floor(num/10000)+'万' : num
			},
			yindao(index){
				var ydflag = localStorage.getItem("yd")
				if (!ydflag) {
					if (index==1) {
						this.yd_flag1 = false
						localStorage.yd = 'true'
					}
					// if (index==1) {
					// 	this.yd_flag1 = false
					// 	this.yd_flag2 = true
					// }
					// if (index==2) {
					// 	this.yd_flag2 = false
					// 	localStorage.yd = 'true'
					// }
				} 
			},
			
			yindao_iframe(index){
				var ydflag = localStorage.getItem("yindao_iframe")
				if (!ydflag) {
					if (index==1) {
						this.yd_iframe1 = false
						this.yd_iframe2 = true
					}
					if (index==2) {
						this.yd_iframe2 = false
						this.yd_iframe3 = true
					}
					if (index==3) {
						this.yd_iframe3 = false
						localStorage.yindao_iframe = 'true'
					}
				} 
			},
			getQrcode(){
				let url = "https://mediaapi.hebei.com.cn/duanwu2026/index?otherOpenId="+wxopenid+"&userid="+this.userid
				QRCode.toDataURL(url, { width: 200, margin: 1 }).then(qrCodeUrl => {
					this.qrCode = qrCodeUrl
					let imgs = new Image()
					imgs.src = this.hbList[this.hb_act2].poster_bigurl
					imgs.onload = ()=>{
						this.$nextTick(() => {
							this.showHbImg()
						})
					}
					
					
				}).catch(err => {
					
					Toast('二维码生成失败')
					console.error(err)
				})
			},
			fsdm(){
				console.log("this.detail_index:",this.$refs['danmaku0'])
				if(this.dm_act==null){
					Toast('请选择弹幕')
					return
				}
				this.$refs['danmaku'+this.detail_index][0].add(this.dmList[this.dm_act]);
				this.dm_act=null
				this.dm_pup = false
				Toast('发送成功')
				
			},
			schb(){
				this.hb_pup = true
			},
			dianzan(index){
				this.list[index].zan++
				// ==================== 【点赞动画新增-开始】每次点赞重新播放约2.2秒全屏特效 ====================
				clearTimeout(this.prideFxTimer)
				this.prideFxVisible = false
				this.$nextTick(()=>{
					this.prideFxKey++
					this.prideFxVisible = true
					this.prideFxTimer = setTimeout(()=>{ this.prideFxVisible = false }, 2200)
				})
				// ==================== 【点赞动画新增-结束】全屏特效触发逻辑 ====================
				// 生成一个随机颜色、位置、大小的飘起爱心
				const id = ++this.heart_id
				this.hearts.push({
					id: id,
					img: this.heart_imgs[Math.floor(Math.random()*this.heart_imgs.length)],
					left: 80 + Math.random()*12,
					size: 22 + Math.random()*18,
					duration: 1.6 + Math.random()*1.2
				})
				// 动画结束后移除
				setTimeout(()=>{
					this.hearts = this.hearts.filter(h => h.id !== id)
				}, 3000)
			},
			schbFn(){
				if(this.hb_act2==null){
					Toast('请选择模板')
					return
				}
				if(this.hb_act==null){
					Toast('请选择个性化文字')
					return
				}
				this.loading = true
				getFwl().then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data && data.data) {
						this.fwl_num = data.data.pv
					}
					this.showHb()
				}).catch(function(err) {
					this.showHb()
				})
				
				
			},
			showHb(){
				
				let url = "https://mediaapi.hebei.com.cn/tsddzznpro/index?otherOpenId="+wxopenid+"&userid="+this.userid
				QRCode.toDataURL(url, { width: 200, margin: 1 }).then(qrCodeUrl => {
					this.qrCode = qrCodeUrl
					this.$nextTick(() => {
						this.showHbImg()
					})
					
					
					
					
				}).catch(err => {
					
					 Toast('生成海报失败')
					console.error(err)
					this.loading = false
				})
				
			},
			showHbImg(){
				var domElement = this.$refs.shareDiv
				if (!domElement) {
					this.loading = false
					return
				}
				html2canvas(domElement, {
				  dpi: 300,
				  scale: 1,
				  width: domElement.offsetWidth,
				  height: domElement.offsetHeight,
				  useCORS: true,
				  async: false
				}).then(canvas => {
				  var context = canvas.getContext('2d')
				  context.mozImageSmoothingEnabled = false
				  context.webkitImageSmoothingEnabled = false
				  context.msImageSmoothingEnabled = false
				  context.imageSmoothingEnabled = false
				  this.hb_img = canvas.toDataURL('jpg/jpeg', 1.0)
				  this.hb_flag = true
				  this.hb_act2=null
				  this.hb_act=null
				  this.loading = false
				}).catch(() => {
				  this.loading = false
				  Toast('生成海报失败')
				})
			},
			goDetailYear(year){
				if(year==2026){
					// 点击“前往2026”：播放当前视频，待视频播放结束后再渐隐按钮、渐显2026详情
					if(this.video_playing) return
					const video = this.getActiveVideo()
					if(video){
						this.video_playing = true
						video.currentTime = 0
						video.play()
						this.$refs.bgm.pause()
					}
					return
				}
				// 点击“返回1976”：渐隐2026详情，渐显1976详情
				this.detail_year = year
				this.$forceUpdate()
			},
			onBuildVideoEnded(){
				// 视频播放完成停在最后一帧，渐隐“前往2026”按钮，渐显建筑2026详情
				this.video_playing = false
				this.video_played = true
				this.detail_year = 2026
				this.achievementVisible = false
				this.$refs.bgm.play()
			},
			setVideoPoster(e){
				// 截取视频第一帧作为封面
				const video = e.target
				if(video.poster || !video.videoWidth) return
				try{
					const canvas = document.createElement('canvas')
					canvas.width = video.videoWidth
					canvas.height = video.videoHeight
					canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
					video.poster = canvas.toDataURL('image/jpeg', 0.8)
				}catch(err){
					// 截取失败时忽略，视频加载后默认显示首帧
				}
			},
			getActiveVideo(){
				if(!this.$refs.detailSwiper || !this.$refs.detailSwiper.$swiper) return null
				const swiper = this.$refs.detailSwiper.$swiper
				const activeSlide = swiper.slides[swiper.activeIndex]
				return activeSlide ? activeSlide.querySelector('video') : null
			},
			hyh(){
				getDmList().then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data && data.data) {
						this.dmList = data.data
					}
				}).catch(function(err) {
				  
				})
			},
			hyh2(){
				getDmList().then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data && data.data) {
						this.hb_dmList = data.data
					}
				}).catch(function(err) {
				  
				})
			},
			getPosterFn(){
				getPoster().then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data && data.data) {
						this.hbList = data.data
						for (let index = 0; index < this.hbList.length; index++) {
							let poster_bigurl = this.hbList[index].poster_bigurl;
							poster_bigurl = poster_bigurl+'?t='+Math.random()
							this.hbList[index].poster_bigurl = poster_bigurl
						}
					}
				}).catch(function(err) {
				  
				})
			},
			getDmListFn(){
				getDmList().then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data && data.data) {
						this.dmList = data.data
						this.dmList2 = data.data
						this.hb_dmList = data.data
					}
				}).catch(function(err) {
				  
				})
			},
			getListFn(){
				getList().then(res => {
					var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
					if (data && data.data) {
						this.list = data.data
						
					}
				}).catch(function(err) {
				  
				})
			},
			handleStart() {
				// 点击开始，后续跳转到下一页
				this.page_index = 2
				this.$nextTick(()=>{
					this.$refs.videoPlayer.play()
				})
			},
			onVideoEnded(){
				this.page_index = 3
				this.$refs.bgm.play()
				var ydflag = localStorage.getItem("yd")
				if (!ydflag) {
					this.yd_flag1 = true
				} 
			},
			tiaoguo(){
				this.page_index = 3
				this.$refs.bgm.play()
				var ydflag = localStorage.getItem("yd")
				if (!ydflag) {
					this.yd_flag1 = true
				} 
			},
			fanhui(index){
				this.page_index = index
				if(index==2){
					this.$nextTick(()=>{
						this.$refs.videoPlayer.play()
					})
				}
				this.dm_pup = false
				this.hb_pup = false
			},
			skbh(year){
				if(this.switching) return
				this.targetYear = year
				// 切回1976用庄严肃穆风格，切到2026用科技感风格
				this.warpMode = year === 1976 ? 'solemn' : 'tech'
				this.switching = true
				// 动画进行到白闪峰值时切换年代
				setTimeout(()=>{
					this.year = year
				}, 600)
				setTimeout(()=>{
					this.switching = false
				}, 1200)
			},
			build(index,year){
				this.achievementVisible = false
				this.detail_year = 1976
				this.video_played = false
				this.video_playing = false
				this.detail_index = index
				this.page_index = 4
				this.detail_data = this.list[index]
				this.$nextTick(()=>{
					// 组件模式下，直接操作组件实例slideTo目标index
					if(this.$refs.detailSwiper && this.$refs.detailSwiper.$swiper){
						this.$refs.detailSwiper.$swiper.slideToLoop(index, 0)
						this.playActiveVideo()
					}
				})

			},
			playActiveVideo(){
				if(!this.$refs.detailSwiper || !this.$refs.detailSwiper.$swiper) return
				const swiper = this.$refs.detailSwiper.$swiper
				// 暂停所有视频并回到首帧（含loop复制的slide），进入详情页后视频保持静止，不自动播放
				const videos = this.$refs.detailSwiper.$el.querySelectorAll('video')
				videos.forEach(v => {
					v.pause()
					this.$refs.bgm.play()
					v.currentTime = 0
				})
				this.video_playing = false
				this.video_played = false
				this.achievementVisible = false
				// 滑动切换后，所有slide回到1976初始状态（视频静止首帧，仅显示“前往2026”按钮）
				this.detail_year = 1976
				// 用swiper内部的slides[activeIndex]定位，和activeIndex同步
				const activeSlide = swiper.slides[swiper.activeIndex]
				if(activeSlide){
					this.detail_index = swiper.realIndex
					this.detail_data = this.list[this.detail_index]
				}
			}
		},
	computed: {
		// 【本次新增】将视差坐标传给地图场景的 --scene-x / --scene-y
		sceneStyle(){
			return {
				'--scene-x': this.sceneX,
				'--scene-y': this.sceneY
			}
		}
	}
}
</script>


<style scoped>
	.page {
		position: relative;
		width: 100%;
		min-height: 100vh;
		background-color: #dcdcdc;
		overflow: hidden;
		font-size: 0;
	}
	.page4{
		position: relative;
		width: 100%;
		min-height: 100vh;
		overflow: hidden;
	}
	.bg_1976{
		background-color: #241b0f;
	}
	.bg_2026{
		background-color: #07182c;
	}
	.bg {
		
		width: 100%;
		height: 100vh;
	}

	/* ==================== 【本次新增】首页电影感：暗角、纪念光束与漂浮尘埃 ==================== */
	.home-page{
		background: #090805;
		animation: pageReveal 1.1s ease-out both;
	}
	.home-page .bg{
		animation: homeKenBurns 10s ease-out both;
		transform-origin: 50% 42%;
	}
	.home-vignette,
	.home-light,
	.home-dust{
		position: absolute;
		inset: 0;
		pointer-events: none;
	}
	.home-vignette{
		background: radial-gradient(ellipse at center, transparent 38%, rgba(0,0,0,.62) 100%);
		box-shadow: inset 0 0 70px rgba(0,0,0,.48);
	}
	.home-light{
		left: -35%;
		width: 55%;
		background: linear-gradient(105deg, transparent 20%, rgba(255,226,157,.18) 50%, transparent 72%);
		filter: blur(8px);
		mix-blend-mode: screen;
		animation: memorialLight 5.8s ease-in-out infinite;
	}
	.home-dust i{
		position: absolute;
		width: 3px;
		height: 3px;
		border-radius: 50%;
		background: #ffe2a0;
		box-shadow: 0 0 8px rgba(255,213,128,.85);
		opacity: 0;
		animation: dustFloat linear infinite;
	}
	@keyframes pageReveal{ from{opacity:0;filter:blur(8px)} to{opacity:1;filter:none} }
	@keyframes homeKenBurns{ from{transform:scale(1.07)} to{transform:scale(1)} }
	@keyframes memorialLight{ 0%,15%{transform:translateX(0);opacity:0} 45%{opacity:1} 85%,100%{transform:translateX(245%);opacity:0} }
	@keyframes dustFloat{ 0%{transform:translate3d(0,14px,0) scale(.5);opacity:0} 20%{opacity:.75} 80%{opacity:.35} 100%{transform:translate3d(18px,-80px,0) scale(1.3);opacity:0} }

	.btn-start {
		position: absolute;
		top: 75%;
		left: 50%;
		width: 37.5%;
		transform: translateX(-50%);
		animation: breathe 1.6s ease-in-out infinite;
	}
	.qipao2{
		background-image: url(../assets/qipao/2.png);
		background-size: auto 100%;
		background-repeat: repeat-x;
		font-size: 32px;
		line-height: 63px;
		color: #fff;
		padding: 0 40px;
	}
	.logo {
		position: absolute;
		top: 92.7%;
		left: 50%;
		width: 29.5%;
		transform: translateX(-50%);
	}

	@keyframes breathe {
		0%, 100% {
			transform: translateX(-50%) scale(1);
		}
		50% {
			transform: translateX(-50%) scale(1.06);
		}
	}
	
	.video-player{
		width: 100vw;
		height: 100vh;
		object-fit: contain;
		background-color: #000;
	}
	
	.tiaoguo{
		position: fixed;
		top: 15px;
		left: 12px;
		width: 90px;
		z-index: 99;
	}
	.tiaoguo2{
		position: fixed;
		top: 15px;
		right: 12px;
		width: 90px;
		z-index: 99;
	}
	.build{
		position: absolute;
		width: 27%;
		z-index: 3;
		transform-origin: 50% 75%;
		will-change: transform, filter;
	}
	.build img{
		width: 100%;
	}
	.build .build_name{
		background-color: #fff;
		font-size: 0.9rem;
		color: #333333;
		border-radius: 15px;
		padding: 2px 8px;
		margin-top: 3px;
		position: relative;
		text-align: center;
		font-weight: bold;
		white-space: nowrap;
	}
	.suofang11{
		animation: scale11 2s linear infinite;
	}
	@keyframes scale11 {
		0%{
			transform: scale(1);
		}
		50%{
			transform: scale(0.9);
		}
		100%{
			transform: scale(1);
		}
	}
	.suofang{
		animation: scale 2s linear infinite;
	}
	@keyframes scale {
		0%{
			transform: scale(1);
		}
		50%{
			transform: scale(0.95);
		}
		100%{
			transform: scale(1);
		}
	}
	.suofang2{
		animation: scale2 2s linear infinite;
	}
	@keyframes scale2 {
		0%{
			transform: scale(1);
		}
		50%{
			transform: scale(1.2);
		}
		100%{
			transform: scale(1);
		}
	}
	.shang{
		/* 【本次修改】上滑提示改为“停留→柔和上浮→淡出→复位”，避免原动画突然跳回 */
		animation: shang 2.4s cubic-bezier(.4,0,.2,1) infinite;
		transform-origin:center;
		will-change:transform,opacity;
	}
	@keyframes shang {
		0%,18%{
			transform:translate3d(0,2px,0) scale(.98);
			opacity:.72;
		}
		45%{
			transform:translate3d(0,-8px,0) scale(1.02);
			opacity:1;
		}
		62%{
			transform:translate3d(0,-14px,0) scale(1);
			opacity:0;
		}
		63%{
			transform:translate3d(0,5px,0) scale(.97);
			opacity:0;
		}
		82%,100%{
			transform:translate3d(0,2px,0) scale(.98);
			opacity:.72;
		}
	}
	.build_1976 img{
		box-shadow: 0 5px 22px rgba(73, 41, 2, 0.5);
		border-radius: 10px;
	}
	.build_2026 img{
		box-shadow: 0 5px 15px rgba(0, 38, 113, 0.6);
		border-radius: 10px;
	}
	.delay0{
		animation-delay: 0s;
	}
	.delay1{
		animation-delay: 0.3s;
	}
	.delay2{
		animation-delay: 0.8s;
	}
	.delay3{
		animation-delay: 1.1s;
	}
	.delay4{
		animation-delay: 1.6s;
	}
	.threeDView{
		position: absolute;
		width: 100%;
		bottom: 7vh;
		left: 0%;
		text-align: center;
		z-index: 4;
	}
	
	.tiaoguo3{
		margin-top: 10px;
		margin-left: 12px;
		width: 90px;
		z-index: 99;
		position: relative;
	}
	
	.tiaoguo4{
		position: absolute;
		bottom: 20px;
		left: 12px;
		width: 90px;
		z-index: 99;
	}
	/* iframe页顶部场景切换 */
	.iframe-tabbar{
		display: flex;
		align-items: center;
		padding: 8px 4px 0;
		position: relative;
		justify-content: space-around;
		height: 50px;
	}
	.iframe-arrow{
		width: 16px;
		flex-shrink: 0;
	}
	.iframe-swiper{
		flex: 1;
		width: 0;
	}
	.iframe-tab{
		text-align: center;
		color: rgba(255, 255, 255, 0.8);
		font-size: 0.85rem;
		/* padding: 3px 10px; */
		white-space: nowrap;
		overflow: hidden;
		background-color: rgba(106, 114, 120, 0.56);
		font-weight: 600;
		border-radius: 15px;
		width: 28%;
		box-sizing: border-box;
		padding: 3px 0;
	}
	.iframe-tab-act{
		background-color: #FFFFFF;
		color: #666666;
		font-size: 1.1rem;
		border: 1rpx solid #979797;
	}

	/* ==================== 【本次新增】地图页：背景推进、暗角、柔光、景深和视差 ==================== */
	.timeline-page{ animation: sceneReveal .8s ease-out both; }
	.map-cinematic-bg,
	.map-vignette,
	.map-light{
		position: absolute;
		inset: 0;
		pointer-events: none;
	}
	.map-cinematic-bg{
		z-index: 0;
		background-size: 100% 100%;
		background-position: center;
		animation: mapKenBurns 12s ease-in-out infinite alternate;
		will-change: transform;
	}
	.map-cinematic-bg-1976{background-image: url(../assets/bg1.png);}
	.map-cinematic-bg-2026{background-image: url(../assets/bg2.png);}
	.map-vignette{
		z-index: 2;
		background: radial-gradient(ellipse at 50% 43%, transparent 42%, rgba(0,0,0,.42) 100%);
		box-shadow: inset 0 0 55px rgba(0,0,0,.32);
	}
	.map-light{
		z-index: 2;
		left: -65%;
		width: 50%;
		background: linear-gradient(105deg, transparent 18%, rgba(255,224,154,.16) 48%, transparent 76%);
		filter: blur(10px);
		mix-blend-mode: screen;
		animation: mapLightPass 7s ease-in-out infinite;
	}
	.bg_2026 .map-light{
		background: linear-gradient(105deg, transparent 18%, rgba(197,232,255,.14) 48%, transparent 76%);
	}
	@keyframes mapKenBurns{
		0%{transform:scale(1.025) translate3d(-.4%,0,0);}
		100%{transform:scale(1.07) translate3d(.6%,-.5%,0);}
	}
	@keyframes mapLightPass{
		0%,18%{transform:translateX(0);opacity:0;}
		42%{opacity:1;}
		78%,100%{transform:translateX(330%);opacity:0;}
	}
	.scene-depth,
	.ambient-particles{
		position:absolute;
		inset:-4%;
		pointer-events:none;
	}
	.scene-depth{ transition:transform .35s ease-out; }
	.scene-depth-back{
		z-index:1;
		transform:translate(calc(var(--scene-x) * -6px), calc(var(--scene-y) * -4px));
		background:radial-gradient(circle at 50% 35%, rgba(255,255,255,.13), transparent 48%);
	}
	.scene-depth-front{
		z-index:2;
		transform:translate(calc(var(--scene-x) * 9px), calc(var(--scene-y) * 6px));
		background:linear-gradient(180deg, transparent 65%, rgba(0,0,0,.24));
	}
	.ambient-particles{z-index:2;overflow:hidden;}
	.ambient-particles i{
		position:absolute;
		width:4px;height:4px;border-radius:50%;
		animation:ambientRise linear infinite;
	}
	.bg_1976 .ambient-particles i{background:rgba(222,190,125,.6);box-shadow:0 0 5px rgba(150,103,43,.4);}
	@keyframes ambientRise{0%{transform:translateY(35px) scale(.6);opacity:0}20%{opacity:.8}100%{transform:translate(14px,-100px) scale(1.2);opacity:0}}
	@keyframes sceneReveal{from{opacity:0;transform:scale(1.035);filter:blur(5px)}to{opacity:1;transform:scale(1);filter:none}}
	.skbh{
		
		width: 35%;
		animation: scale 2s linear infinite;
	}
	.threeD{
		width: 35%;
		animation: scale 2s linear infinite;
		margin-top: 6vh;
	}
	
	.build-video-player{
		width: 100vw;
		height: calc(100vw / 1080 * 1442);
		object-fit: contain;
	}
	/* 详情页垂直滑动 swiper */
	.detail-swiper{
		width: 100%;
		height: 100vh;
	}
	.detail-swiper .swiper-slide{
		position: relative;
		width: 100%;
		height: 100vh;
		overflow: hidden;
	}
	.tc_title{
		
		font-size: 1.2rem;
		color: #3D648A;
		font-weight: bold;
	}
	/* ==================== 【本次新增】海报与弹幕底部弹窗关闭按钮 ==================== */
	.custom-popup-content{
		position:relative;
	}
	.popup-close-btn{
		position:absolute;
		top:12px;
		right:12px;
		z-index:20;
		dis:flex;
		align-items:center;
		justify-content:center;
		width:32px;
		height:32px;
		padding:0;
		border:1px solid rgba(61,100,138,.22);
		border-radius:50%;
		background:rgba(255,255,255,.9);
		box-shadow:0 4px 12px rgba(29,67,105,.16);
		color:#3D648A;
		font-size:22px;
		font-weight:300;
		line-height:1;
	}
	.popup-close-btn:active{
		transform:scale(.92);
		background:#eef6ff;
	}
	.tc_title2{
		font-size: 0.9rem;
		color: #3D648A;
		
	}
	
	/* ==================== 【本次修改】底部弹幕选择项：渐变胶囊与选中反馈 ==================== */
	.dm_item{
		padding: 8px 16px;
		display: inline-block;
		background: linear-gradient(135deg, rgba(240,248,255,.92), rgba(218,235,252,.74));
		border-radius: 18px;
		border: 1px solid rgba(122, 169, 210, .3);
		box-shadow: 0 4px 12px rgba(40,85,130,.08), inset 0 1px 0 rgba(255,255,255,.85);
		font-size: 0.86rem;
		color: #3D648A;
		margin-bottom: 12px;
		margin-right: 10px;
		transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
	}
	.dm_item:active{transform:scale(.96);}
	.dm_act{
		color: #fff;
		background: linear-gradient(135deg, #608FBD, #776EB7);
		border: 1px solid rgba(255,255,255,.8);
		box-shadow: 0 5px 14px rgba(75,86,155,.3), inset 0 1px 0 rgba(255,255,255,.35);
		font-weight: bold;
	}
	.hb_item{
		background: rgba(214, 234, 255, 0.39);
		border-radius: 10px;
		font-size: 0.9rem;
		color: #3D648A;
		width: 32%;
		position: relative;
		font-size: 0;
	}
	.hb_act{
		color: #3D648A;
		background: linear-gradient(to bottom, rgba(214, 234, 255, 1),rgba(183, 184, 230, 1));
	}
	/* ==================== 【本次修改】飘屏弹幕：1976暖金、2026蓝色玻璃质感 ==================== */
	.dmlist{
		display: inline-flex;
		align-items: center;
		min-height: 32px;
		padding: 6px 15px;
		border-radius: 18px;
		font-size: 0.82rem;
		font-weight: 500;
		letter-spacing: .02em;
		white-space: nowrap;
		color: #fff;
		background: linear-gradient(110deg, rgba(38,30,20,.78), rgba(91,68,35,.62));
		border: 1px solid rgba(255,231,178,.65);
		box-shadow: 0 5px 16px rgba(0,0,0,.22), inset 0 1px 0 rgba(255,255,255,.18);
		backdrop-filter: blur(7px);
		-webkit-backdrop-filter: blur(7px);
		text-shadow: 0 1px 3px rgba(0,0,0,.45);
	}
	.danmaku-stage-2026 .dmlist{
		background: linear-gradient(110deg, rgba(20,72,108,.78), rgba(67,109,153,.62));
		border-color: rgba(190,239,255,.72);
		box-shadow: 0 5px 18px rgba(2,36,66,.28), inset 0 1px 0 rgba(255,255,255,.22);
		text-shadow: 0 1px 3px rgba(0,35,60,.55);
	}

	/* ==================== 【本次新增】2026城市成就入口、弹层与三张成就卡 ==================== */
	.achievement-trigger{
		position:absolute;
		top:96px;
		right:0;
		z-index:12;
		display:flex;
		align-items:center;
		gap:9px;
		margin:0;
		padding:7px 9px 7px 7px;
		border:1px solid rgba(196,239,255,.72);
		border-right:0;
		border-radius:25px 0 0 25px;
		background:linear-gradient(110deg,rgba(12,54,88,.94),rgba(48,116,157,.9));
		box-shadow:-5px 7px 20px rgba(0,31,57,.3),-1px 0 14px rgba(95,210,246,.2),inset 0 1px 0 rgba(255,255,255,.2);
		color:#fff;
		backdrop-filter:blur(7px);
		-webkit-backdrop-filter:blur(7px);
		animation:achievementTriggerFloat 2.8s ease-in-out infinite;
		transform-origin:right center;
		overflow:visible;
	}
	.achievement-trigger::before{
		content:'NEW';
		position:absolute;
		top:-8px;
		left:31px;
		padding:1px 6px;
		border:1px solid rgba(255,244,202,.9);
		border-radius:8px 8px 8px 2px;
		background:linear-gradient(135deg,#F3DA85,#B8872E);
		box-shadow:0 3px 9px rgba(105,70,10,.35);
		color:#55390E;
		font-size:.48rem;
		font-weight:800;
		letter-spacing:.5px;
		animation:newBadgePulse 1.8s ease-in-out infinite;
	}
	.achievement-trigger::after{
		content:'';
		position:absolute;
		inset:-4px 0 -4px -4px;
		z-index:-1;
		border-radius:29px 0 0 29px;
		border:1px solid rgba(102,220,255,.35);
		animation:triggerHalo 2.2s ease-out infinite;
	}
	.achievement-trigger-icon{
		display:flex;
		align-items:center;
		justify-content:center;
		width:29px;height:29px;
		border-radius:50%;
		background:linear-gradient(135deg,#EBD388,#A67A28);
		box-shadow:0 0 10px rgba(238,203,105,.42);
		color:#fff8dd;
		font-size:.85rem;
		position:relative;
	}
	.achievement-trigger-icon i{font-style:normal;animation:achievementStar 2.4s ease-in-out infinite;}
	.achievement-trigger > span:nth-child(2){display:flex;flex-direction:column;align-items:flex-start;}
	.achievement-trigger b{font-size:.78rem;letter-spacing:1px;line-height:1.25;}
	.achievement-trigger small{font-size:.58rem;color:rgba(224,246,255,.72);line-height:1.35;}
	.achievement-trigger > i{margin-left:1px;font-size:1.15rem;font-style:normal;color:#BDEFFF;animation:achievementArrow 1.25s ease-in-out infinite;}
	@keyframes achievementTriggerFloat{
		0%,100%{transform:translate3d(0,0,0);}
		50%{transform:translate3d(-4px,-4px,0);}
	}
	@keyframes newBadgePulse{0%,100%{transform:scale(1)}50%{transform:scale(1.08);box-shadow:0 3px 13px rgba(239,198,87,.65)}}
	@keyframes triggerHalo{0%{opacity:.75;transform:scale(1)}75%,100%{opacity:0;transform:scale(1.08)}}
	@keyframes achievementStar{0%,100%{transform:rotate(0) scale(1)}50%{transform:rotate(90deg) scale(1.16)}}
	@keyframes achievementArrow{0%,100%{transform:translateX(0);opacity:.65}50%{transform:translateX(3px);opacity:1}}
	.achievement-overlay{
		position:absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		inset:0;
		z-index:999;
		display:flex;
		align-items:flex-end;
		justify-content:center;
		padding:0 0 8vh;
		background:linear-gradient(180deg,rgba(0,16,30,.08),rgba(0,18,33,.62));
		backdrop-filter:blur(2px);
		-webkit-backdrop-filter:blur(2px);
	}
	.achievement-panel{
		position:relative;
		width: 86%;
		margin: 0 auto;
		padding:16px 13px 11px;
		border:1px solid rgba(164,224,250,.35);
		border-radius:22px;
		background:linear-gradient(155deg,rgba(8,40,66,.94),rgba(25,73,105,.92));
		box-shadow:0 18px 45px rgba(0,16,30,.42),inset 0 1px 0 rgba(255,255,255,.12);
		font-size: initial;
	}
	.achievement-close{
		position:absolute;
		top:8px;right:10px;
		width:27px;height:27px;
		border:1px solid rgba(205,242,255,.28);
		border-radius:50%;
		background:rgba(255,255,255,.08);
		color:#DDF8FF;
		font-size:1.15rem;
		line-height:22px;
	}
	.achievement-heading{
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		margin-bottom: 10px;
		color: rgba(230,249,255,.95);
		font-size: .78rem;
		letter-spacing: 3px;
		text-shadow: 0 2px 8px rgba(0,42,75,.7);
	}
	.achievement-heading span{
		width: 28px;
		height: 1px;
		background: linear-gradient(90deg, transparent, rgba(159,229,255,.8));
	}
	.achievement-heading span:last-child{transform:rotate(180deg);}
	.achievement-card{
		position: relative;
		font-size: 0;
		margin-bottom: 8px;
		animation: achievementIn .65s cubic-bezier(.2,.8,.2,1) both;
	}
	/* 【本次修改】后台图片已有完整设计，直接展示，不再添加代码边框、底色或编号 */
	.achievement-image{
		display:block;
		width:100%;
		object-fit:contain;
	}
	.achievement-card-0{animation-delay:.08s;}
	.achievement-card-1{animation-delay:.22s;}
	.achievement-card-2{animation-delay:.36s;}
	.achievement-copy{
		display:flex;
		align-items:center;
		justify-content:space-between;
		gap:8px;
		width:100%;
	}
	.achievement-title{
		color:#fff;
		font-size:.78rem;
		font-weight:600;
		line-height:1.3;
		letter-spacing:.5px;
		text-shadow:0 2px 4px rgba(0,31,56,.5);
	}
	.achievement-year{
		flex:0 0 auto;
		padding:2px 6px;
		border-radius:9px;
		color:#173D5D;
		font-size:.63rem;
		font-weight:700;
		background:linear-gradient(135deg,#FFF0BD,#E7BE62);
		box-shadow:0 2px 7px rgba(0,25,45,.25);
	}
	.achievement-mark{
		position:absolute;
		right:11px;top:50%;
		display:flex;
		gap:2px;
		transform:translateY(-50%);
	}
	.achievement-mark i{
		display:block;
		width:2px;
		height:12px;
		border-radius:2px;
		background:#8BE9FF;
		opacity:.45;
	}
	.achievement-mark i:nth-child(2){height:19px;opacity:.85;}
	.achievement-mark i:nth-child(3){height:15px;opacity:.62;}
	@keyframes achievementIn{
		from{opacity:0;transform:translate3d(0,18px,0);filter:blur(4px);}
		to{opacity:1;transform:translate3d(0,0,0);filter:none;}
	}
	.achievement-hint{text-align:center;color:rgba(211,240,251,.48);font-size:.6rem;letter-spacing:1px;margin-top:3px;}
	.achievement-sheet-enter-active,.achievement-sheet-leave-active{transition:opacity .3s ease;}
	.achievement-sheet-enter-active .achievement-panel,.achievement-sheet-leave-active .achievement-panel{transition:transform .38s cubic-bezier(.2,.8,.2,1),opacity .25s ease;}
	.achievement-sheet-enter,.achievement-sheet-leave-to{opacity:0;}
	.achievement-sheet-enter .achievement-panel,.achievement-sheet-leave-to .achievement-panel{transform:translateY(35px);opacity:0;}
	
	/* 点赞飘爱心 */
	.like-box{
		position: absolute;
		right: 10px;
		bottom: -5px;
		z-index: 1;
		text-align: center;
	}
	.like-btn{
		width: 35px;
	}
	.like-num{
		color: #FFEA9B;
		font-size: 0.85rem;
	}
	.fly-heart{
		position: absolute;
		bottom: 20px;
		z-index: 98;
		pointer-events: none;
		opacity: 0;
		animation: flyHeart linear both;
	}
	.yd_iframe{
		position: absolute;
		top:0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: #000;
		z-index: 9999;
	}
	/* ==================== 【本次新增】最终纪念海报：悬浮、动态阴影与高光掠过 ==================== */
	.poster-preview-stage{
		position:relative;
		width:75%;
		margin:8px auto 0;
		perspective:900px;
	}
	.poster-preview-stage::before{
		content:'';
		position:absolute;
		left:10%;right:10%;bottom:-14px;
		height:22px;
		border-radius:50%;
		background:rgba(0,0,0,.48);
		filter:blur(12px);
		animation:posterShadow 3.4s ease-in-out infinite;
	}
	.poster-preview-card{
		position:relative;
		width:100%;
		font-size:0;
		overflow:hidden;
		border-radius:3px;
		box-shadow:0 18px 44px rgba(0,0,0,.46),0 0 0 1px rgba(255,255,255,.16);
		animation:posterFloat 3.4s ease-in-out infinite;
		will-change:transform;
	}
	.poster-preview-img{display:block;width:100%;}
	.poster-preview-shine{
		position:absolute;
		top:-35%;bottom:-35%;
		left:-55%;
		width:34%;
		background:linear-gradient(90deg,transparent,rgba(255,255,255,.08),rgba(255,248,218,.62),rgba(255,255,255,.08),transparent);
		filter:blur(2px);
		transform:skewX(-18deg);
		mix-blend-mode:screen;
		pointer-events:none;
		animation:posterShine 4.6s ease-in-out infinite;
	}
	@keyframes posterFloat{
		0%,100%{transform:translate3d(0,0,0) rotateX(0deg);}
		50%{transform:translate3d(0,-9px,0) rotateX(1deg);}
	}
	@keyframes posterShadow{
		0%,100%{transform:scale(.9);opacity:.5;}
		50%{transform:scale(1.04);opacity:.32;}
	}
	@keyframes posterShine{
		0%,18%{left:-55%;opacity:0;}
		30%{opacity:1;}
		62%{left:125%;opacity:.75;}
		72%,100%{left:125%;opacity:0;}
	}
	@keyframes flyHeart {
		0%{
			transform: translate(0, 0) scale(0.4);
			opacity: 0;
		}
		10%{
			transform: translate(-1vw, -5vh) scale(1);
			opacity: 1;
		}
		80%{
			opacity: 1;
		}
		100%{
			transform: translate(-7vw, -48vh) scale(1.1);
			opacity: 0;
		}
	}
	
	/* ==================== 【点赞动画新增-开始】以下 pride-fx 全部为点赞全屏特效样式 ====================
	 * 包含：渐变光晕、点阵、扩散圆环、彩色粒子、玻璃状态卡及其关键帧动画。
	 */
	.pride-fx{
		position:fixed;
		inset:0;
		z-index:100001;
		overflow:hidden;
		pointer-events:none;
		background:radial-gradient(circle at 50% 50%,rgba(255,255,255,.08),rgba(18,30,58,.06) 55%,transparent 82%);
		backdrop-filter:blur(1px);
		-webkit-backdrop-filter:blur(1px);
		animation:prideFxFade 2.2s ease both;
	}
	.pride-fx-red-wave{
		position:absolute;
		left:50%;top:50%;
		width:115vmin;height:115vmin;
		margin:-57.5vmin 0 0 -57.5vmin;
		border-radius:50%;
		background:conic-gradient(from 210deg,rgba(0,222,255,.7),rgba(87,75,255,.6),rgba(255,63,145,.52),rgba(255,183,72,.5),rgba(0,222,255,.7));
		filter:blur(32px);
		mix-blend-mode:screen;
		animation:prideAurora 2.2s cubic-bezier(.2,.75,.2,1) both;
	}
	.pride-fx-rays{
		position:absolute;
		left:50%;top:50%;
		width:90vmin;height:90vmin;
		margin:-45vmin 0 0 -45vmin;
		border-radius:50%;
		background:radial-gradient(circle,rgba(255,255,255,.48) 0 1.2px,transparent 1.8px);
		background-size:15px 15px;
		-webkit-mask:radial-gradient(circle,#000 0,rgba(0,0,0,.55) 32%,transparent 70%);
		mask:radial-gradient(circle,#000 0,rgba(0,0,0,.55) 32%,transparent 70%);
		animation:prideRays 2.2s ease-out both;
	}
	.pride-fx-ring{
		position:absolute;
		left:50%;top:50%;
		width:28vmin;height:28vmin;
		margin:-14vmin 0 0 -14vmin;
		border:1.5px solid rgba(132,224,255,.9);
		border-radius:50%;
		box-shadow:0 0 25px rgba(65,190,255,.48),inset 0 0 16px rgba(168,100,255,.18);
		animation:prideRing 1.55s cubic-bezier(.1,.7,.2,1) both;
	}
	.pride-fx-ring.ring-two{animation-delay:.18s;}
	.pride-fx-sparks{position:absolute;left:50%;top:50%;}
	.pride-fx-sparks i{
		position:absolute;
		width:6px;height:6px;
		margin:-2px 0 0 -2px;
		border-radius:2px;
		background:var(--spark-color);
		box-shadow:0 0 11px rgba(116,214,255,.82);
		transform:rotate(var(--spark-rotate));
		animation:prideSpark 1.5s cubic-bezier(.15,.65,.25,1) both;
	}
	.pride-fx-copy{
		position:absolute;
		left:50%;top:50%;
		width:250px;
		padding:22px 18px 19px;
		border:1px solid rgba(255,255,255,.48);
		border-radius:22px;
		transform:translate(-50%,-50%);
		text-align:center;
		color:#fff;
		background:linear-gradient(145deg,rgba(255,255,255,.3),rgba(214,233,255,.12));
		box-shadow:0 18px 48px rgba(20,41,82,.22),inset 0 1px 0 rgba(255,255,255,.62),inset 0 -1px 0 rgba(255,255,255,.12),0 0 30px rgba(112,210,255,.14);
		backdrop-filter:blur(24px) saturate(1.45);
		-webkit-backdrop-filter:blur(24px) saturate(1.45);
		text-shadow:0 2px 8px rgba(21,42,79,.28);
		animation:prideCopy 2.2s cubic-bezier(.2,.8,.2,1) both;
	}
	.pride-fx-copy::before{
		content:'';
		position:absolute;
		inset:1px;
		border-radius:20px;
		pointer-events:none;
		background:linear-gradient(125deg,rgba(255,255,255,.28),transparent 34%,transparent 70%,rgba(117,213,255,.1));
		box-shadow:inset 0 0 18px rgba(255,255,255,.06);
	}
	.pride-fx-copy > *{position:relative;z-index:1;}
	.pride-fx-star{
		dis:flex;
		align-items:center;
		justify-content:center;
		width:42px;height:42px;
		margin:0 auto 11px;
		border-radius:50%;
		color:#fff;
		font-size:22px;
		font-weight:700;
		background:linear-gradient(135deg,#24D8C7,#4C7CFF 58%,#B45CFF);
		box-shadow:0 7px 20px rgba(66,126,255,.35);
		animation:prideStar 1.2s ease-out both;
	}
	.pride-fx-title{font-size:20px;font-weight:700;letter-spacing:1px;}
	.pride-fx-title em{margin-left:3px;color:#8FF6EC;font-size:15px;font-style:normal;text-shadow:0 0 10px rgba(99,239,228,.35);}
	.pride-fx-line{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:9px;color:rgba(255,255,255,.72);font-size:10px;letter-spacing:1.5px;}
	.pride-fx-line span{width:18px;height:1px;background:linear-gradient(90deg,transparent,rgba(181,235,255,.75));}
	.pride-fx-line span:last-child{transform:rotate(180deg);}
	@keyframes prideFxFade{0%{opacity:0}7%,72%{opacity:1}100%{opacity:0}}
	@keyframes prideAurora{0%{opacity:0;transform:scale(.25) rotate(-30deg)}24%{opacity:1;transform:scale(1.03) rotate(0)}72%{opacity:.9}100%{opacity:0;transform:scale(1.35) rotate(22deg)}}
	@keyframes prideRays{0%{opacity:0;transform:scale(.35) rotate(-8deg)}24%{opacity:1}72%{opacity:.85}100%{opacity:0;transform:scale(1.4) rotate(14deg)}}
	@keyframes prideRing{0%{opacity:0;transform:scale(.4)}22%{opacity:.8}100%{opacity:0;transform:scale(3.2)}}
	@keyframes prideSpark{0%{opacity:0;transform:translate(0,0) rotate(var(--spark-rotate)) scale(.2)}18%{opacity:1}100%{opacity:0;transform:translate(var(--spark-x),var(--spark-y)) rotate(var(--spark-rotate)) scale(.7)}}
	@keyframes prideCopy{0%{opacity:0;transform:translate(-50%,-50%) scale(.72);filter:blur(6px)}18%{opacity:1;transform:translate(-50%,-50%) scale(1.04);filter:blur(0)}28%,74%{opacity:1;transform:translate(-50%,-50%) scale(1)}100%{opacity:0;transform:translate(-50%,-54%) scale(.98)}}
	@keyframes prideStar{0%{opacity:0;transform:scale(.3) rotate(-25deg)}42%{opacity:1;transform:scale(1.12) rotate(4deg)}100%{transform:scale(1) rotate(0)}}
	/* ==================== 【点赞动画新增-结束】点赞全屏特效样式结束 ==================== */
	

	.zhezhao1976{
		background: linear-gradient( 180deg, rgba(60,51,35,0) 0%, #3C3323 35%, #3C3323 100%);
		position: absolute;bottom: 0;left: 0;width: 100%;box-sizing: border-box;height: calc(100vh - 100vw / 1080 * 1442 + 25vh);
	}
	.zhezhao1976_playing{
		background: linear-gradient( 180deg, rgba(60,51,35,0) 0%, #3C3323 35%, #3C3323 100%);
	}
	.zhezhao2026{
		background: linear-gradient( 180deg, rgba(61,100,138,0) 0%, #3D648A 35%, #3D648A 100%);
		position: absolute;bottom: 0;left: 0;width: 100%;box-sizing: border-box;height: calc(100vh - 100vw / 1080 * 1442 + 25vh);
	}
	
	.detail_title{
		text-align: center;
		color: #fff;
		font-size: 1.1rem;
		font-weight: bold;
		width: 70%;
		margin: 0 auto;
		margin-top: 10px;
	}
	.detail_title_bg_1976{
		background-image: url(../assets/xian1976.png);
		background-size: 100% 100%;
		padding-bottom: 20px;
	}
	.detail_title_bg_2026{
		background-image: url(../assets/xian2026.png);
		background-size: 100% 100%;
		padding-bottom: 20px;
	}
	/* 详情区块渐隐渐显过渡 */
	.fade-enter-active{
		transition: opacity .6s ease;
	}
	.fade-enter{
		opacity: 0;
	}
	.detail_content{
		margin-top: 10px;
		color: #fff;
		font-size: 0.95rem !important;
		line-height: 1.5;
		text-align: justify;
		min-height: 0;
	}
	/* ==================== 【本次新增】1976/2026说明文字折叠、渐隐和展开按钮 ==================== */
	.detail-content-wrap{
		position: relative;
		max-height: 6.2rem;
		overflow: hidden;
		transition: max-height .45s cubic-bezier(.2,.7,.2,1);
	}
	.detail-content-wrap.is-expanded{
		max-height: 28vh;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}
	.detail-content-fade{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 2.8rem;
		pointer-events: none;
		background: linear-gradient(180deg, rgba(60,51,35,0), #3C3323 88%);
		transition: opacity .25s ease;
	}
	.detail-content-wrap-2026 .detail-content-fade{
		background: linear-gradient(180deg, rgba(61,100,138,0), #3D648A 88%);
	}
	.detail-content-wrap.is-expanded .detail-content-fade{
		opacity: 0;
	}
	.detail-expand-btn{
		display: block;
		margin: 4px auto 0;
		padding: 4px 13px;
		border: 1px solid rgba(255,230,174,.45);
		border-radius: 18px;
		outline: none;
		background: rgba(255,255,255,.08);
		color: #FFE6AE;
		font-size: .78rem;
		line-height: 1.2;
	}
	.detail-expand-btn-2026{
		border-color: rgba(181,241,255,.5);
		color: #D5F8FF;
	}
	.expand-arrow{
		display: inline-block;
		margin-left: 4px;
		font-size: 1rem;
		transform: translateY(-1px);
		transition: transform .25s ease;
	}
	.expand-arrow.up{
		transform: rotate(180deg) translateY(-1px);
	}
	
	/* ==================== 【本次修改-开始】海报/弹幕按钮动效与小型人数标签 ==================== */
	.action-motion{
		transform-origin:center;
		animation:actionGentleFloat 3s ease-in-out infinite;
		will-change:transform;
	}
	.action-motion-danmaku{animation-delay:-1.5s;}
	.action-motion-img{
		display:block;
		filter:drop-shadow(0 5px 9px rgba(22,42,78,.2));
		transition:transform .16s ease,filter .16s ease;
	}
	.action-motion:active .action-motion-img{
		transform:scale(.94);
		filter:brightness(1.08) drop-shadow(0 2px 5px rgba(22,42,78,.18));
	}
	.sc-view,
	.fb-view{
		position:absolute;
		top:0;
		right:-2px;
		z-index:2;
		padding:2px 5px;
		border:1px solid rgba(255,255,255,.72);
		border-radius:9px 9px 9px 3px;
		color:#fff;
		font-size:.48rem;
		line-height:1.15;
		white-space:nowrap;
		transform:translateY(-42%);
		box-shadow:0 3px 9px rgba(30,25,80,.2),inset 0 1px 0 rgba(255,255,255,.2);
		animation:countTagFloat 2.4s ease-in-out infinite;
	}
	.sc-view{background:linear-gradient(135deg,rgba(164,105,187,.94),rgba(82,52,139,.94));}
	.fb-view{background:linear-gradient(135deg,rgba(53,190,181,.94),rgba(16,126,126,.94));animation-delay:-1.2s;}
	.sc-view::before,
	.fb-view::before{
		content:'';
		display:inline-block;
		width:3px;height:3px;
		margin-right:3px;
		border-radius:50%;
		background:#FFF1A8;
		box-shadow:0 0 5px rgba(255,235,137,.85);
		vertical-align:middle;
		animation:countDotPulse 1.5s ease-in-out infinite;
	}
	.sc-view .bold,.fb-view .bold{padding:0 2px;color:#FFF0A5;font-size:.58rem;font-weight:800;}
	@keyframes actionGentleFloat{
		0%,100%{transform:translateY(0) scale(1);}
		50%{transform:translateY(-3px) scale(1.015);}
	}
	@keyframes countTagFloat{
		0%,100%{transform:translateY(-42%);}
		50%{transform:translateY(-52%);}
	}
	@keyframes countDotPulse{
		0%,100%{opacity:.55;transform:scale(.8);}
		50%{opacity:1;transform:scale(1.25);}
	}
	/* ==================== 【本次修改-结束】海报/弹幕按钮动效与小型人数标签 ==================== */
	
	/* ===== 时空切换动画 ===== */
	/* 内容空间穿梭：缩放 + 模糊 + 提亮 */
	.warping .build,
	.warping .threeD{
		animation: warpZoom 1.2s ease both;
	}
	@keyframes warpZoom {
		0% { transform: scale(1); filter: none; }
		50% { transform: scale(1.12); filter: blur(5px) brightness(1.8) saturate(1.4); }
		100% { transform: scale(1); filter: none; }
	}
	/* 全屏遮罩 */
	.warp-mask{
		position: absolute;
		top: 0; left: 0; right: 0; bottom: 0;
		z-index: 99;
		overflow: hidden;
		background: radial-gradient(circle at 50% 50%, rgba(10, 40, 120, 0.55), rgba(2, 6, 23, 0.92) 75%);
		animation: maskFade 1.2s ease both;
	}
	@keyframes maskFade {
		0% { opacity: 0; }
		20% { opacity: 1; }
		80% { opacity: 1; }
		100% { opacity: 0; }
	}
	/* 时空隧道同心光环 */
	.warp-tunnel{
		position: absolute;
		top: -50%; left: -50%; right: -50%; bottom: -50%;
		background: repeating-radial-gradient(circle at 50% 50%, rgba(0, 229, 255, 0.35) 0 2px, transparent 2px 60px);
		animation: tunnelIn 1.2s ease-in both;
	}
	@keyframes tunnelIn {
		0% { transform: scale(0.3); opacity: 0; }
		30% { opacity: 1; }
		100% { transform: scale(1.6); opacity: 0; }
	}
	/* 旋转能量环 */
	.warp-ring{
		position: absolute;
		top: 50%; left: 50%;
		width: 80vmin; height: 80vmin;
		margin: -40vmin 0 0 -40vmin;
		border-radius: 50%;
		background: conic-gradient(from 0deg, transparent, rgba(0, 229, 255, 0.9), transparent 30%);
		-webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px));
		mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 3px));
		animation: ringSpin 0.8s linear infinite;
	}
	@keyframes ringSpin {
		to { transform: rotate(360deg); }
	}
	/* 横向扫描线 */
	.warp-scan{
		position: absolute;
		left: 0; right: 0; top: -5%;
		height: 3px;
		background: linear-gradient(90deg, transparent, #4df3ff, #ffffff, #4df3ff, transparent);
		box-shadow: 0 0 18px 4px rgba(77, 243, 255, 0.8);
		animation: scanMove 0.6s linear infinite;
	}
	@keyframes scanMove {
		to { top: 105%; }
	}
	/* 故障干扰条 */
	.warp-glitch{
		position: absolute;
		left: 0; width: 100%; height: 8px;
		background: rgba(0, 229, 255, 0.25);
		mix-blend-mode: screen;
	}
	.warp-glitch.g1{
		top: 30%;
		animation: glitchBar 0.25s steps(2) infinite;
	}
	.warp-glitch.g2{
		top: 65%; height: 14px;
		background: rgba(255, 0, 128, 0.2);
		animation: glitchBar 0.25s steps(2) infinite reverse;
	}
	@keyframes glitchBar {
		0% { transform: translateX(-6%); opacity: 0; }
		50% { opacity: 0.9; }
		100% { transform: translateX(6%); opacity: 0; }
	}
	/* 白闪（年代切换瞬间） */
	.warp-flash{
		position: absolute;
		top: 0; left: 0; right: 0; bottom: 0;
		background: #dff9ff;
		opacity: 0;
		animation: flash 1.2s ease both;
	}
	@keyframes flash {
		0%, 40% { opacity: 0; }
		50% { opacity: 0.85; }
		60%, 100% { opacity: 0; }
	}
	/* 目标年代数字 */
	.warp-year{
		position: absolute;
		top: 50%; left: 50%;
		transform: translate(-50%, -50%);
		font-size: 72px;
		font-weight: bold;
		color: #eafcff;
		letter-spacing: 8px;
		text-shadow: 0 0 12px #4df3ff, 0 0 40px #0077ff;
		animation: yearPop 1.2s ease both;
	}
	@keyframes yearPop {
		0% { opacity: 0; transform: translate(-50%, -50%) scale(1.6); filter: blur(8px); }
		25% { opacity: 1; filter: blur(0); }
		75% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
		100% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); filter: blur(6px); }
	}

	/* ===== 庄严肃穆风格（切回1976） ===== */
	/* 内容：缓慢沉降 + 泛黄做旧 + 压暗 */
	.warping-solemn .build,
	.warping-solemn .threeD{
		animation: warpSolemn 1.2s ease both;
	}
	@keyframes warpSolemn {
		0% { transform: scale(1); filter: none; }
		50% { transform: scale(1.04); filter: blur(3px) sepia(0.85) brightness(0.65); }
		100% { transform: scale(1); filter: none; }
	}
	/* 遮罩：深褐近黑，缓缓笼罩 */
	.warp-mask.solemn{
		background: radial-gradient(circle at 50% 50%, rgba(58, 36, 10, 0.55), rgba(8, 5, 1, 0.94) 75%);
	}
	/* 隧道光环：暗金色，缓慢扩散 */
	.warp-mask.solemn .warp-tunnel{
		background: repeating-radial-gradient(circle at 50% 50%, rgba(201, 163, 92, 0.28) 0 2px, transparent 2px 70px);
		/* animation: tunnelSolemn 1.2s ease both; */
	}
	@keyframes tunnelSolemn {
		0% { transform: scale(0.85); opacity: 0; }
		40% { opacity: 0.8; }
		100% { transform: scale(1.15); opacity: 0; }
	}
	/* 能量环：暗金色，缓慢旋转 */
	.warp-mask.solemn .warp-ring{
		background: conic-gradient(from 0deg, transparent, rgba(216, 180, 106, 0.8), transparent 30%);
		/* animation: ringSpin 2.4s linear infinite; */
	}
	/* 扫描线：暖金色柔光，缓慢单次扫过 */
	.warp-mask.solemn .warp-scan{
		background: linear-gradient(90deg, transparent, #c9a35c, #fff3d6, #c9a35c, transparent);
		box-shadow: 0 0 22px 6px rgba(201, 163, 92, 0.55);
		/* animation: scanMove 1.2s ease-in-out both; */
	}
	/* 去掉数字故障干扰条 */
	.warp-mask.solemn .warp-glitch{
		display: none;
	}
	/* 闪光：柔和暖白，低透明度 */
	.warp-mask.solemn .warp-flash{
		background: #efe0bd;
		/* animation: flashSolemn 1.2s ease both; */
	}
	@keyframes flashSolemn {
		0%, 35% { opacity: 0; }
		50% { opacity: 0.5; }
		65%, 100% { opacity: 0; }
	}
	/* 年代数字：楷体暗金，缓缓浮现 */
	.warp-mask.solemn .warp-year{
		font-family: "STKaiti", "KaiTi", serif;
		color: #f3e3c0;
		letter-spacing: 14px;
		text-shadow: 0 0 12px #d8a94f, 0 0 40px #7a5410;
		/* animation: yearSolemn 1.2s ease both; */
	}
	@keyframes yearSolemn {
		0% { opacity: 0; transform: translate(-50%, -50%) scale(1.05); filter: blur(4px); }
		35% { opacity: 1; filter: blur(0); }
		80% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
		100% { opacity: 0; }
	}
</style>
